function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Tag, Select, Space, message, Skeleton, Timeline, Form, Input, DatePicker, Steps, Card, notification, Image } from "antd";
import UserSuggestionBox from "./forms/UserSuggestionBox";
import Common from "./includes/Common";
import { useNavigate } from 'react-router-dom';
import { InfoSquareFill, EyeFill, TicketPerforatedFill, SearchHeart, ClockHistory, CalendarEventFill, CashStack, GraphUpArrow, GlobeEuropeAfrica } from 'react-bootstrap-icons';
import DisplayHomeFeed from "./pieces/DisplayHomeFeed";
import NewEventBox from "./NewEventBox";
import { useOutletContext } from "react-router-dom";
import EventView from "./EventView";
import dayjs from "dayjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var Meta = Card.Meta;
var RangePicker = DatePicker.RangePicker;
var HomeContent = function HomeContent(_ref) {
  var showDrawer = _ref.showDrawer;
  var navigate = useNavigate();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    domains = _useState2[0],
    setDomains = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    homeEvents = _useState4[0],
    setHomeEvents = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    domainOptions = _useState6[0],
    setDomainOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    user = _useState8[0],
    setUser = _useState8[1];
  var _useOutletContext = useOutletContext(),
    setIsEventBoxVisible = _useOutletContext.setIsEventBoxVisible;
  var _useOutletContext2 = useOutletContext(),
    setConnectDrawerVisible = _useOutletContext2.setConnectDrawerVisible;
  var _useOutletContext3 = useOutletContext(),
    handleShowEventDetails = _useOutletContext3.handleShowEventDetails;
  var _useOutletContext4 = useOutletContext(),
    handleNewTicket = _useOutletContext4.handleNewTicket;
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isAuthProcessing = _useState10[0],
    setIsAuthProcessing = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataLoading = _useState12[0],
    setIsDataLoading = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    countryId = _useState14[0],
    setCountryId = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    eventCategoryId = _useState16[0],
    setEventCategoryId = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    month = _useState18[0],
    setMonth = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    keyword = _useState20[0],
    setKeyword = _useState20[1];
  var _useState21 = useState(8),
    _useState22 = _slicedToArray(_useState21, 2),
    limit = _useState22[0],
    setLimit = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    offset = _useState24[0],
    setOffset = _useState24[1];
  var handleChange = function handleChange(value) {
    //setHomeEvents([]);
    setEventCategoryId(value);
    setLimit(8);
    setOffset(0);
    setMonth(0);
    setKeyword("");
    document.querySelector('.domain-home-box').scrollIntoView({
      behavior: 'smooth'
    });
  };
  var handleNewEvent = function handleNewEvent() {
    setIsAuthProcessing(true);
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        setIsEventBoxVisible(true);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
        setConnectDrawerVisible(true);
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsAuthProcessing(false);
    });
  };
  var loadEvents = function loadEvents() {
    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    setIsDataLoading(true);
    axios.post(Common.baseApiUrl + 'geteventsfromfilters', {
      country_id: countryId,
      event_category_id: eventCategoryId,
      keyword: keyword,
      month: month,
      limit: limit,
      offset: offset
    }).then(function (response) {
      if (response.data.status == 200) {
        response.data.events.forEach(function (e) {
          setHomeEvents(function (prev) {
            return [].concat(_toConsumableArray(prev), [e]);
          });
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'geteventcategories')]).then(function (response) {
      if (response[0].data.status == 200) {
        setDomainOptions([]);
        setDomains(response[0].data.categories);
        response[0].data.categories.forEach(function (c) {
          setDomainOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: "".concat(c.label, " (").concat(c.events.length, ")")
            }]);
          });
        });
      }
    })["catch"](function (error) {
      console.log('Erreur pendant le chargement');
    });
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        setUser(response.data.user);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
      }
    });
  }, []);
  useEffect(function () {
    setHomeEvents([]);
    loadEvents();
  }, [eventCategoryId, countryId, keyword, limit, offset, month]);
  useEffect(function () {
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        setUser(response.data.user);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "lp-main-content",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center",
                padding: "35px"
              },
              children: [/*#__PURE__*/_jsx(Row, {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  children: /*#__PURE__*/_jsx(Image, {
                    preview: false,
                    src: "drawables/nl2_rm.png",
                    width: "100%"
                  })
                })
              }), /*#__PURE__*/_jsx("h4", {
                style: {
                  color: "#684422"
                },
                children: "La solution parfaite pour g\xE9rer les entr\xE9es de vos \xE9venements en toute libert\xE9"
              }), /*#__PURE__*/_jsx(Row, {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 9,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Form, {
                    size: "large",
                    style: {
                      marginTop: "35px"
                    },
                    layout: "vertical",
                    onFinish: function onFinish(values) {
                      setEventCategoryId(0);
                      setLimit(8);
                      setOffset(0);
                      setKeyword(values.keyword);
                      setMonth(dayjs(values.period).month());
                      document.querySelector('.domain-home-box').scrollIntoView({
                        behavior: 'smooth'
                      });
                    },
                    children: /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 3,
                        md: 2,
                        sm: 12,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "period",
                          children: /*#__PURE__*/_jsx(DatePicker, {
                            placeholder: "Choisir le mois",
                            block: true,
                            style: {
                              width: "180px"
                            },
                            picker: "month"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 6,
                        md: 8,
                        sm: 12,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "keyword",
                          children: /*#__PURE__*/_jsx(Input, {
                            block: true,
                            style: {
                              width: "100%"
                            },
                            allowClear: true,
                            variant: "filled",
                            placeholder: "Nom \xE9v\xE8nement, artiste, panel ..."
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 3,
                        md: 2,
                        sm: 12,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            htmlType: "submit",
                            type: "primary",
                            children: /*#__PURE__*/_jsxs("b", {
                              children: [/*#__PURE__*/_jsx(SearchHeart, {
                                size: 24
                              }), " Trouver des \xE9venements"]
                            })
                          })
                        })
                      })]
                    })
                  })
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
          className: "d-flex justify-content-center",
          children: /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 7
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-right-container",
              children: [/*#__PURE__*/_jsx("div", {
                className: "domain-home-box",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "home-cat-cta",
                  children: [/*#__PURE__*/_jsx(Space, {
                    direction: "horizontal",
                    wrap: true,
                    children: /*#__PURE__*/_jsx("h5", {
                      children: "Payez vos tickets en toute s\xE9curit\xE9"
                    })
                  }), /*#__PURE__*/_jsx(Steps, {
                    size: "default",
                    items: [{
                      title: /*#__PURE__*/_jsx("b", {
                        children: "TROUVES"
                      })
                    }, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "RESERVES"
                      })
                    }, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "ACCEDES EN TOUTE LIBERTE!"
                      })
                    }]
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
                    children: /*#__PURE__*/_jsx(Select, {
                      style: {
                        width: 250
                      },
                      placeholder: "Cherchez une cat\xE9gorie",
                      size: "large",
                      onChange: handleChange,
                      optionLabelProp: "label",
                      optionFilterProp: "label",
                      options: domainOptions
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Row, {})]
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "page-container",
      style: {
        paddingTop: '0px'
      },
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [homeEvents.map(function (e) {
            return /*#__PURE__*/_jsx(Col, {
              lg: 6,
              children: /*#__PURE__*/_jsx(EventView, {
                event: e,
                handeDisplayDetails: handleShowEventDetails,
                handleNewTicket: handleNewTicket
              })
            }, e.id);
          }), isDataLoading && /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        style: {
          paddingTop: '0px',
          background: "#F5F5F1",
          padding: "38px 0px"
        },
        children: /*#__PURE__*/_jsxs(Container, {
          children: [/*#__PURE__*/_jsx(Row, {
            className: "d-flex justify-content-center",
            children: /*#__PURE__*/_jsx(Col, {
              lg: 11,
              md: 12,
              children: /*#__PURE__*/_jsx("h2", {
                style: {
                  color: "#6B4322"
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "Vous etes promoteur d'\xE9venements ? Naatou, c'est pour vous"
                })
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius",
                style: {
                  padding: "20px"
                },
                children: /*#__PURE__*/_jsx(Steps, {
                  direction: "vertical",
                  items: [{
                    title: /*#__PURE__*/_jsx("b", {
                      children: "CREEZ UN COMPTE"
                    }),
                    icon: /*#__PURE__*/_jsx(ClockHistory, {}),
                    description: /*#__PURE__*/_jsx("span", {
                      children: "Vous etes promoteur d'\xE9v\xE8nement ? Cr\xE9ez votre compte en une minute"
                    })
                  }, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "AJOUTEZ VOTRE EVENEMENT"
                    }),
                    icon: /*#__PURE__*/_jsx(CalendarEventFill, {}),
                    description: /*#__PURE__*/_jsx("span", {
                      children: "Mettez votre evenement en Annonces et definissez le prix d'acc\xE8s"
                    })
                  }, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "ENCAISSEZ VOS TICKETS EN LIGNE"
                    }),
                    icon: /*#__PURE__*/_jsx(CashStack, {}),
                    description: /*#__PURE__*/_jsx("span", {
                      children: "Encaissez les tickets en toute s\xE9curit\xE9"
                    })
                  }, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "CONSULTEZ LES ENTREES"
                    }),
                    icon: /*#__PURE__*/_jsx(GraphUpArrow, {}),
                    description: /*#__PURE__*/_jsx("span", {
                      children: "Visionez l'\xE9volution des ventes et prenez des d\xE9cisions"
                    })
                  }, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "PARTOUT ET EN TEMPS REEL"
                    }),
                    icon: /*#__PURE__*/_jsx(GlobeEuropeAfrica, {})
                  }]
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx("div", {
                className: "textBox1",
                children: /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsxs(Col, {
                    lg: 8,
                    md: 8,
                    sm: 8,
                    xs: 9,
                    children: [/*#__PURE__*/_jsx("h2", {
                      children: "G\xE9rez l'acc\xE8s \xE0 vos \xE9v\xE8nement en toute s\xE9curit\xE9"
                    }), /*#__PURE__*/_jsxs("p", {
                      children: [/*#__PURE__*/_jsx("span", {
                        children: "Naatou"
                      }), " est un outils con\xE7u pour simplifier et s\xE9curiser l'acc\xE8s \xE0 vos \xE9venements"]
                    }), /*#__PURE__*/_jsx("p", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Appelez le +224 613 696904 pour parler avec un conseill\xE9 commercial"
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      onClick: function onClick() {
                        handleNewEvent();
                      },
                      size: "large",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Ou commencer maintenant !"
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 3,
                    children: /*#__PURE__*/_jsx("img", {
                      src: "drawables/pro-rel.png",
                      style: {
                        width: '100%'
                      }
                    })
                  })]
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 8,
            children: /*#__PURE__*/_jsx(Row, {
              className: "d-flex justify-content-center",
              children: /*#__PURE__*/_jsxs(Col, {
                lg: 8,
                children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Image, {
                  preview: false,
                  src: "drawables/had_c.png"
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: '#FFD492',
                marginTop: "12px",
                marginBottom: '8px',
                padding: '15px',
                borderRadius: '0px 14px 14px 14px',
                minHeight: '500px'
              },
              children: /*#__PURE__*/_jsx(UserSuggestionBox, {})
            })
          })]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
    })]
  });
};
export default HomeContent;